import React from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";

const CorporateGiftingSlider = ({ product }) => {
  if (!product) return null;

  return (
    product.status === true && (
      <div className="corparate-img">
        <Link to={`/corporategift/${product._id}`}>
          <img src={product.image[0]} alt="corporate gift" />
        </Link>
      </div>
    )
  );
};

export default CorporateGiftingSlider;
